import React from 'react';

// We could add our assets inside the 'Javascript' folder to allow webpack to compile them
// The downside is that we will end up with duplicated files in the codebase until we convert fully
// This would also avoid the nasty absolute path
// e.g. import ... from 'assets/images/<filename>.svg'
import checkCircleGreenIcon from '../../../assets/images/shared/icons/check-circle-green.svg';
import infoIcon from '../../../assets/images/shared/icons/info-yellow.svg';

/**
 * Renders a <ApprovalCreditLimitContent/> component
 * @param props
 * @param props.message - Object containing message data
 * @param props.isProductPage - - Prop to determine if component is rendered on the product show page
 */
const ApprovalCreditLimitContent = ({ message, isProductPage }) => {
  const { title, pageShowTitle, subtitle, creditLimit } = message;

  return (
    <span className="fl ai-c l-fl-col oa-credit-limit__content-wrapper">
      <img
        src={creditLimit >= 0 ? checkCircleGreenIcon : infoIcon}
        className="oa-credit-limit__icon"
        alt=""
        width="28"
        height="28"
      />
      <span className="fl fw-w jc-sb fl-auto">
        <span
          className={`oa-credit-limit__title ${isProductPage ? 'ta-l' : ''}`}>
          {isProductPage ? pageShowTitle : title}
        </span>
        {creditLimit >= 0 && (
          <>
            <span className="oa-credit-limit__price">&pound;{creditLimit}</span>
            <span className="oa-credit-limit__text">{subtitle}</span>
          </>
        )}
      </span>
    </span>
  );
};

export default ApprovalCreditLimitContent;
